import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Arg, Entity, Field, Query } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { EntityData } from '@adornis/baseql/entities/types.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { LevumiItemCategory } from '../../../db/enums/CampusLevumiEnums.js';
import { CampusLevumiLevel } from './CampusLevumiLevel.js';

@Entity()
export class CampusLevumiItemGerman extends MongoEntity {
  public static override _class = 'CampusLevumiItemGerman';
  public static override _collectionName = 'campus-levumi-german-items';

  static blankRegex = /\$/g;

  @validate(nonOptional())
  @Field(type => String)
  public levelID!: string;

  @Field(type => CampusLevumiLevel, {
    resolve: function (this: CampusLevumiItemGerman) {
      return async () => {
        const col = await getRawCollection<EntityData<CampusLevumiLevel>>(CampusLevumiLevel._collectionName);
        const res = (await col.findOne({ _id: this.levelID })) as Maybe<CampusLevumiLevel>;
        return res;
      };
    },
  })
  public level!: CampusLevumiLevel;

  @Field(type => String, {
    default: v => v ?? LevumiItemCategory.ARGUMENT,
  })
  public category!: LevumiItemCategory;

  @Field(type => String, {
    default: v => v ?? '',
  })
  public sentence!: string;

  @Field(type => String, {
    default: v => v ?? '',
  })
  public answer!: string;

  @Field(type => [String], {
    default: v => v ?? [],
  })
  public distractors!: string[];

  @Query(type => Int)
  public static numberOfLevumiGermanItemsPerLevel(@Arg('levumiLevelID', type => String) levumiLevelID: string) {
    return async (gqlFields: void) => {
      const col = await getRawCollection<CampusLevumiItemGerman>(CampusLevumiItemGerman._collectionName);
      const filtered = await col.find({ levelID: levumiLevelID }).toArray();
      return filtered.length;
    };
  }
}
